import { getCoreDataSecurityMonitoredObjectsSlice } from './get';
import { getCoreDataSecurityUsageSlice } from '../usage/get';
import { postDataSecurityMonitoredObjects } from '@api/data-security';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityMonitoredObjectsSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [
			getCoreDataSecurityMonitoredObjectsSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitoredObjects,
			getCoreDataSecurityUsageSlice.asyncActionCreators.repeatGetCoreDataSecurityUsage
		]
	},
	name: 'CoreDataSecurityMonitoredObjects',
	receive: false,
	request: true,
	requestHandler: postDataSecurityMonitoredObjects,
	yieldType: SagaYieldType.Latest
});
